export const AUTH_TOKEN_KEY = 'access_token';
export const USER_KEY = 'auth_user';
export const API_URL = process.env.NEXT_PUBLIC_API_URL || "http://localhost:5000/api";

